import { TheWestLiveBroadcast } from '@news-mono/web-common'
import React from 'react'
import {
    StyledWestLiveWaves,
    StyledWestLiveWaves2,
    StyledWestLiveWaves3,
} from './TheWestLiveWaves.styled'

interface TheWestLiveWavesProps {
    broadcast?: TheWestLiveBroadcast
}

export const TheWestLiveWaves: React.FC<TheWestLiveWavesProps> = ({
    broadcast,
}) => (
    <React.Fragment>
        <StyledWestLiveWaves broadcast={broadcast} />
        <StyledWestLiveWaves3 broadcast={broadcast} />
        <StyledWestLiveWaves2 broadcast={broadcast} />
    </React.Fragment>
)
TheWestLiveWaves.displayName = 'TheWestLiveWaves'
